exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nh3[data-v-277e32e8] {\n  text-align: left;\n  padding-top: 10px;\n  margin-left: 4px;\n  /*margin-bottom: 0px;*/\n}\n", ""]);
